module.exports = __webpack_public_path__ + "static/img/weixin_pic.fc72bc5e.png";